<template>
    <span class="add-to-order">
        <button class="btn btn-xs btn-default" @click="showDialog = true">
            <span class="fa fa-pencil"></span>
            Edit
        </button>

        <div class="text-left">
            <OrderItemDialog
                v-if="showDialog"
                :orderItemId="primaryOrderItemId"
                @hide="showDialog = false"
                @saved="orderItemSaved"
                />
        </div>
    </span>
</template>

<script>
export default {
    components: {
        OrderItemDialog: require('@/components/orderitems/OrderItemDialog.vue').default,
    },
    props: ['productId', 'minimumQuantity', 'primaryOrderItemId'],
    data() {
        return {
            showDialog: false,
        };
    },
    methods: {
        orderItemSaved(id) {
            this.showDialog = false;

            let orderItem = this.$store.state.data.orderItems.byId[id];

            if (orderItem) {
                jQuery(`.item-${orderItem.id} .column-quantity`).text(orderItem.quantity);
                jQuery(`.item-${orderItem.id} .column-notes`).text(orderItem.notes);
            }
        },
    },
}
</script>
